import { FormattedMessage as FM } from "react-intl";
import { EmptyIcon, SearchIcon } from "components/Icons";

function TableEmptyState({ type }) {
  const isFilter = type === "filter";
  return (
    <tbody>
      <tr>
        <td colSpan={99}>
          <div className="flex justify-center items-center gap-2 px-6 py-12 text-gray-400 bg-white">
            <div className="">
              {isFilter ? (
                <SearchIcon className="size-4 fill-current" />
              ) : (
                <EmptyIcon className="size-4 fill-current" />
              )}
            </div>
            <div className="text-left">
              <span className="text-lg font-medium">
                {isFilter ? (
                  <FM id="table.filter_to_see_data" />
                ) : (
                  <FM id="table.no_data" />
                )}
              </span>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  );
}

export default TableEmptyState;
